module.exports = __webpack_public_path__ + "img/English-06.13a27591.jpg";